import axios, { AxiosResponse } from "axios";
import { Config, Model } from "../types";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://bone.implexvet.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchConfig = async (configId: string): Promise<Config> => {
  try {
    const response: AxiosResponse<Config> = await api.get(
      `/configs/public/${configId}`
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const updateModel = async (
  modelId: string,
  updateData: Partial<Model>
): Promise<Model> => {
  try {
    const response: AxiosResponse<Model> = await api.patch(
      `/configs/models/${modelId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export default api;
